import React from "react";
import { TABLEAU_USERS } from "../../../Routes/NAVIGATION_PATH";
import { Link } from "react-router-dom";
import Table from "react-bootstrap/Table";
import { Nav, Tab } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import myuser from '../../../Assets/programmation.jpg';
import "./TableauUsers.css";

export default function TableauUsers() {
  return (
    <Container fluid>
      <Row>
        <Col className="my-2">
          <Form.Control size="lg" type="text"
           placeholder="Searh.." />
        </Col>
        <Table striped bordered hover responsive>
          <thead>
            <tr className="py-5">
              <th>Nom Complete</th>
              <th>Domaine</th>
              <th>Adresse</th>
              <th>Nbre Etudiant</th>
              <th>Nbre Cours</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>thier diallo</td>
              <td className=" p-2 ">
        <div className="container-im">
          <img className="mab p-2" src={myuser} /> <strong>Programation</strong>
        </div></td>
              <td>hlm</td>
              <td>25</td> <td>47</td>
              <td>
                <button>delet</button>
                <button>delet</button>
                <button>delet</button>
              </td>
            </tr>
            <tr>
              <td>thier diallo</td>
              <td>Programation</td>
              <td>hlm</td>
              <td>25</td> <td>47</td>
              <td>
                <button>delet</button>
                <button>delet</button>
                <button>delet</button>
              </td>
            </tr>
          </tbody>
        </Table>
      </Row>
    </Container>
  );
}
